import {Injectable} from '@angular/core';
import {CustomErrorHandlerService} from './custom-error-handler.service';
import {AuthServerError} from '../types';
import {Router} from '@angular/router';
import { SentryErrorHandler } from '@sentry/angular';
@Injectable({
    providedIn: 'root'
})
export class DefaultErrorHandler extends SentryErrorHandler{

    constructor(
        private errorService: CustomErrorHandlerService,
        private router: Router
    ) {
        super({
            // showDialog: true
        })
    }


    handleError(error: Error): void {
        super.handleError(error)

        this.errorService.handleError(error, '@DefaultErrorHandler');
        if (error instanceof AuthServerError) {
            this.router.navigate(['/']).then();
        }
    }

}
